export const formatPlate = (plate: string) => {
  const firstFormattedPlate = plate.substring(0, 3);
  const secondFormattedPlate = plate.substring(3);

  return `${firstFormattedPlate}-${secondFormattedPlate}`;
};
